import { render } from "./RegionGraphics.vue?vue&type=template&id=321f0d67"
import script from "./RegionGraphics.vue?vue&type=script&lang=js"
export * from "./RegionGraphics.vue?vue&type=script&lang=js"

import "./RegionGraphics.vue?vue&type=style&index=0&id=321f0d67&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__